import React, { useState, useEffect, useRef } from 'react';
import { Button, Typography } from '@material-ui/core';
import { Slices, Redux } from 'spwa-ui-library';
import { getTitleOfItems } from 'spwa-ui-library/esm/utils/helper';
import { orderStatusHelper, decimalChecker } from 'spwa-ui-library/esm/utils/helper.js';
import { FormattedMessage, useIntl } from 'react-intl';
import css from './index.module.scss';
import Box from '@material-ui/core/Box';
import currentOrderIcon from './images/currentOrderIcon.svg';
import format from 'date-fns/format';
import { AiOutlineArrowUp } from '@react-icons/all-files/ai/AiOutlineArrowUp';
import { useNavigate, useLocation } from '@reach/router';
import noImg from '../../assets/no-itm.png';
const { useSelector } = Redux;
const { orderStatusConstants, selectBaseURL, selectCountryValidations } = Slices.configSlice;
const { selectFirstMenu } = Slices.menuSlice;
const { selectCurrentOrders } = Slices.orderSlice;
const { selectCurrentCountry } = Slices.profileSlice;

function CurrentOrderDesktop({ widgetData }) {
  const orderState = useSelector((state) => state.order);
  const nextPage = orderState?.currentOrders?.info?.data?.nextPage;

  const navigate = useNavigate();
  const location = useLocation();
  const ref = useRef(null);
  const intl = useIntl();
  const auth = useSelector((state) => state.auth);
  const profile = useSelector((state) => state.profile);
  const orderStatusArray = useSelector(orderStatusConstants);
  let allOrders = useSelector(selectCurrentOrders);
  const imgBaseUrl = useSelector(selectBaseURL);
  const menu = useSelector(selectFirstMenu);
  const [open, setOpen] = useState(null);
  const [selectedOrders, setSelectedOrders] = useState(3);
  const country = useSelector(selectCurrentCountry).toString().toLowerCase();
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));
  const currency = countryValidations && countryValidations.currency;

  const handleOpen = (e) => {
    setOpen(!open);
    setSelectedOrders(3);
  };
  const handleClickOutside = (event) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setOpen(false);
    }
  };
  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true);
    return () => {
      document.removeEventListener('click', handleClickOutside, true);
    };
  }, []);
  if (!auth.isLoggedIn) {
    return null;
  }
  const handleNavigation = (id, status) => () => {
    if (status === 'PENDING') {
      navigate(`/${intl.locale}/thank-you/` + id);
    } else {
      navigate(`/${intl.locale}/track-order/` + id);
    }
  };
  const openOrderHistory = () => {
    navigate(`/${intl.locale}/order-history`, {
      state: { oldLocation: JSON.parse(JSON.stringify(location)) },
    });
  };

  if (allOrders.length === 0) return null;

  let orders;
  if (allOrders.length > 3) {
    orders = allOrders.slice(0, 3);
  } else {
    orders = allOrders;
  }

  return (
    <>
      <Box ref={ref} className={open ? css.openContainer : css.container}>
        <Box className={css.btnContainer} onClick={handleOpen}>
          {/* <img src={currentOrderIcon} alt="cart-icon" width={34} height={34} /> */}
          <Typography id="previouslyOrdered" className={css.previousItem}>
            <FormattedMessage
              id={orders.length > 1 ? 'current_orders_title' : 'current_order_title'}
              values={{
                count: orders.length,
              }}
              defaultMessage={`You have ${orders.length} Current Orders`}
            />
          </Typography>
          <AiOutlineArrowUp className={open ? css.arrowdownicon : css.arrowupicon} />
        </Box>
        <Box style={{ overflowY: orders.length >= 3 ? 'scroll' : 'none' }}>
          <div className={`${open ? '' : css.hidden}`}>
            {orders.map((item, i) => {
              // const firstItem = item?.itemIds?.[0];
              // const itemDetail = getTitleOfItems(item.itemIds);
              // const imgSrc = item?.assets[0]?.src;
              return (
                <div className={css.order} key={i}>
                  <div className={css.orderMain} onClick={handleNavigation(item._id, item.status)}>
                    {/* <div className={css.itmImg}>
                      <img
                        className={css.imageComponent}
                        width="40"
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = noImg;
                        }}
                        alt={item?.name}
                        src={`${imgSrc}`}
                      />
                    </div> */}
                    <div className={css.orderDetail}>
                      {item.status !== 'PENDING' ? (
                        <>
                          {item?.orderDisplayNumber ? (
                            <h5 className={css.orbNumber}>
                              <FormattedMessage
                                id={'orderdetails_orderno'}
                                defaultMessage="Order No"
                              />{' '}
                              <span className={css.redText}>{item?.orderDisplayNumber}</span>
                            </h5>
                          ) : null}
                        </>
                      ) : (
                        <h5>
                          <FormattedMessage
                            id={'currentOrder_pending'}
                            defaultMessage="Pending Confirmation"
                          />
                        </h5>
                      )}
                      <h4>{''}</h4>
                      <h6>
                        {item?.itemIds.length || item?.itemIdAndTypeIds?.length || 1} item
                        {(item?.itemIds?.length || item?.itemIdAndTypeIds?.length) > 1 && 's'}{' '}
                        <span className={css.verticle}>|</span>
                        <span>
                          {(item?.address?.addressSubType === 'PICKUP' ||
                            item?.address?.addressSubType === 'DINEIN' ||
                            item?.address?.addressSubType === 'STORE') &&
                          item?.status === 'ON_THE_WAY'
                            ? 'READY FOR PICKUP'
                            : orderStatusArray.length > 0 &&
                              orderStatusHelper(item?.status, orderStatusArray)}
                        </span>
                      </h6>
                      <br />
                      <p>{item?.name}</p>
                    </div>
                  </div>
                  <div className={css.bottomSec}>
                    <div className={css.amount}>
                      {item.payment.amount.toFixed(2)} {currency}
                    </div>
                    <div className={css.button}>
                      <Button
                        variant="outlined"
                        color="primary"
                        onClick={handleNavigation(item._id, item.status)}
                      >
                        <FormattedMessage id="navigation_trackOrder" defaultMessage="Track Order" />
                      </Button>
                    </div>
                  </div>

                  <h5 className={css.orderIdInfo}>
                    <span>
                      <FormattedMessage id={'trackorder_orderno'} defaultMessage="Order Id" />.
                      <span className={css.bold}>
                        {' '}
                        {item.country} - {item.uOrderRef}
                      </span>{' '}
                    </span>
                    <span>{` | `}</span>
                    <span>{format(new Date(item.createdAt), 'dd MMM, yyyy')}</span>
                  </h5>
                </div>
              );
            })}
            {nextPage && nextPage != -1 && (
              <Box className={css.flexBox}>
                <Button
                  variant="outlined"
                  color="primary"
                  className={css.desktopButton}
                  onClick={openOrderHistory}
                >
                  <FormattedMessage id={'view_more'} defaultMessage="View More" />
                </Button>
              </Box>
            )}
          </div>
        </Box>
      </Box>
    </>
  );
}
export default CurrentOrderDesktop;
